const FALLBACK_MCP_URL = "https://use.kick.co/mcp";

/** Single source of truth for the MCP endpoint shown and linked on this page. */
export function mcpEndpointUrl(): string {
    return typeof window === "undefined"
        ? FALLBACK_MCP_URL
        : `${window.location.origin}/mcp`;
}

/**
 * Cursor takes the server config as a base64 payload, so it has to be built
 * from the current origin rather than hardcoded, otherwise connecting from a
 * local or staging host would install the production server.
 */
export function cursorMcpInstallUrl(): string {
    const config = btoa(JSON.stringify({ url: mcpEndpointUrl() }));
    return `cursor://anysphere.cursor-deeplink/mcp/install?name=kick&config=${config}`;
}
